import React from 'react';
import styled from 'styled-components';

const Button = styled.button`
    font-size: 21.6px !important;
    background: transparent;
    border: 0;
    color: #0097FE;
`;

const CloseButton = ({ ...rest }) => {
    return <Button {...rest}>
        <i className="far fa-times"></i>
    </Button>;
};

export default React.memo(CloseButton);
